class AudioPlayer extends HTMLElement {
  constructor() {
    super()

    this.audioPlayer = this.querySelector("#audioPlayer")
    this.addEventListener("click", this.audioPlay.bind(this))
  }

  audioPlay() {
    this.audioPlayer.paused
      ? this.audioPlayer.play()
      : this.audioPlayer.pause()
  }
}

customElements.define("audio-player", AudioPlayer)
